import script from "./ConfirmGate.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmGate.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmGate.vue?vue&type=style&index=0&id=0f1ef520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1ef520"]])

export default __exports__